import { render, staticRenderFns } from "./5_ButtonListQuestion.vue?vue&type=template&id=e5914820&scoped=true&"
import script from "./5_ButtonListQuestion.vue?vue&type=script&lang=js&"
export * from "./5_ButtonListQuestion.vue?vue&type=script&lang=js&"
import style0 from "./5_ButtonListQuestion.vue?vue&type=style&index=0&id=e5914820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5914820",
  null
  
)

export default component.exports